import { Box, MultiSelect } from '@mantine/core';
import type { InputProps } from '../../types';
import { Clipboard, ClipboardPlus, Reset } from '@morph-mapper/ui';
import { useFileInteraction } from '@morph-mapper/file-viewer';

export const TextSelectorAdd = ({
  value,
  handleChange,
}: InputProps<string[]>) => {
  const { getPath } = useFileInteraction();
  const inputValue = value ?? '';
  let arrayValue = [];
  if (value != null) {
    arrayValue = typeof value === 'string' ? JSON.parse(value) : value;
    if (!Array.isArray(arrayValue)) arrayValue = [arrayValue];
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {inputValue.length !== 0 ? (
        <ClipboardPlus
          size={'lg'}
          mr={'md'}
          onClick={() => handleChange([...value, getPath() ?? ''])}
        />
      ) : (
        <Clipboard
          size={'lg'}
          mr={'md'}
          onClick={() => handleChange([getPath() ?? ''])}
        />
      )}
      {inputValue.length !== 0 && (
        <Reset
          size={'lg'}
          mr={'md'}
          onClick={() => handleChange([])}
          variant="default"
        />
      )}
      <MultiSelect
        searchable
        creatable
        value={arrayValue ?? []}
        getCreateLabel={(query) => `+ Create ${query}`}
        onChange={handleChange}
        data={[
          ...(arrayValue ?? []).map((word) => ({
            label: JSON.stringify(word).slice(1, -1),
            value: word,
          })),
        ]}
      />
    </Box>
  );
};
